import { gql } from '@soundxyz/gql-string';
import { EthToUsdConversionDocument, useQuery } from '@graphql/reactQuery';

/*#__PURE__*/ gql(/* GraphQL */ `
  query EthToUsdConversion {
    currencies {
      ethToUsd
    }
  }
`);

export function useEthToUsdValue() {
  const { data: ethToUsdData, isInitialLoading } = useQuery(EthToUsdConversionDocument, {
    filterQueryKey: {
      key: 'EthToUsd',
    },
    staleTime: 0,
  });

  return {
    isLoading: isInitialLoading,
    ethToUsd: ethToUsdData?.data.currencies.ethToUsd,
  };
}
